import { MASKED_TEXT } from '../../constants';
const PARENT_SEARCH_DEPTH = 5;
const CLICKABLE_ELEMENTS = ['BUTTON', 'LABEL', 'A', 'INPUT', 'OPTION'];
export function extractMaskedOrTextContent(element, config) {
    if (!element)
        return '';
    const clickableElement = findClickableElement(element, PARENT_SEARCH_DEPTH);
    if (!clickableElement)
        return '';
    return getMaskedOrTextualContent(clickableElement, config);
}
function findClickableElement(element, maxDepth) {
    if (!element || maxDepth <= 0) {
        return null;
    }
    if (CLICKABLE_ELEMENTS.includes(element.nodeName))
        return element;
    return findClickableElement(element.parentElement, maxDepth - 1);
}
function getMaskedOrTextualContent(element, config) {
    if (shouldMaskElement(element, config.maskInputTypes, config.maskClass) ||
        isParentMasked(element, config.maskClass, PARENT_SEARCH_DEPTH)) {
        return MASKED_TEXT;
    }
    const maskedChild = findMaskedChildren(element, config);
    if (maskedChild) {
        return MASKED_TEXT;
    }
    return getTextualContent(element);
}
function isParentMasked(element, maskClass, maxDepth = PARENT_SEARCH_DEPTH) {
    if (!element || maxDepth <= 0) {
        return false;
    }
    if (isMaskedByClass(element.className, maskClass)) {
        return true;
    }
    return isParentMasked(element.parentElement, maskClass, maxDepth - 1);
}
function findMaskedChildren(element, config) {
    if (!element.children)
        return null;
    return Array.from(element.children).find((child) => shouldMaskElement(child, config.maskInputTypes, config.maskClass));
}
function shouldMaskElement(element, maskInputTypes, maskClass) {
    if (!element)
        return false;
    return (isMaskedInput(element, maskInputTypes) ||
        isMaskedByClass(element.className, maskClass));
}
function isMaskedInput(element, maskInputTypes) {
    if (element instanceof HTMLInputElement) {
        const inputType = element.type || 'text';
        return maskInputTypes.includes(inputType);
    }
    return false;
}
function isMaskedByClass(className, maskClass) {
    if (maskClass instanceof RegExp) {
        return maskClass.test(className);
    }
    if (typeof className !== 'string') {
        return false;
    }
    return className.includes(maskClass);
}
function getTextualContent(element) {
    if (element instanceof HTMLInputElement) {
        return element.value || '';
    }
    return 'innerText' in element ? element.innerText : '';
}
